/**
 * Continues support for the opt-out/override functionality in cms-web for fordDirect/adobeLaunch
 *
 * @param {string} project - the project being used, from configuration
 * @param {string} liveScriptLocation  - the value in liveScriptLocation, from configuration
 * @param {string} defaultScriptLocation  - the value in defaultScriptLocation, from configuration
 * @returns array of new script locations if found in siteProperties
 */

const adobeOptOut = (liveScriptLocation, defaultScriptLocation) => {
	return [
		window?.DDC?.siteProperties?.adobeTagManagerUrl || liveScriptLocation,
		window?.DDC?.siteProperties?.adobeTagManagerUrlStaging ||
			defaultScriptLocation
	];
};

export default adobeOptOut;
